import { getDefaultStore } from 'jotai';
import Cookies from 'js-cookie';
import { authAtom, requestIdAtom } from '../store/auth';

/**
 * Utility function to handle complete logout process
 * Clears all auth state, tokens, and Jotai atoms
 */
export const handleCompleteLogout = () => {
  const store = getDefaultStore();

  // Clear Jotai atoms
  store.set(authAtom, null);
  store.set(requestIdAtom, null);

  // Clear cookies
  Cookies.remove('token');
  Cookies.remove('refresh_token');

  // Clear axios headers
  if (typeof window !== 'undefined') {
    window.location.reload();
    window.location.href = '/login';
  }
};
